import styled from '@emotion/styled';

export const LI = styled.li`
  margin-top: ${({ gapBefore }) => (gapBefore ? '1em' : 0)};
  margin-bottom: ${({ gapAfter }) => (gapAfter ? '1em' : 0)};
`;



// WEBPACK FOOTER //
// ./src/components/LE/LI.js